export default "__VITE_ASSET__6SzOkQE___"